import React from 'react';
import dayjs from 'dayjs';
export default function CalOt(date1, date2) {
  const sum = dayjs(date1).diff(dayjs(date2), 'h') - 8;
  if (sum > 0) {
    return sum;
  }
  return 0;
}
